import '../../../src/styles.css'
import Header from '../../components/header/Header';
import { Link } from 'react-router-dom';
import SocialMedia from '../../components/header/SocialMedia';
import CopyRight from '../../components/footer/CopyRight';

// Ícone de localização SVG
const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
    <path d="M8.00008 0C3.58908 0 8.14446e-05 3.589 8.14446e-05 7.995C-0.0289186 14.44 7.69608 19.784 8.00008 20C8.00008 20 16.0291 14.44 16.0001 8C16.0001 3.589 12.4111 0 8.00008 0ZM8.00008 12C5.79008 12 4.00008 10.21 4.00008 8C4.00008 5.79 5.79008 4 8.00008 4C10.2101 4 12.0001 5.79 12.0001 8C12.0001 10.21 10.2101 12 8.00008 12Z" fill="white"/>
  </svg>
);

function Home() {

  return (
    <div className="container">
      
      <Header/>

      <div className="content-one">
        <h1>ECELL DISTRIBUIDORA</h1>
        <span><p>Conectando Você às Melhores</p><p>Peças e Acessórios 📱💚</p></span>
        <SocialMedia/>
      </div>

      <div className="content-two">
        
        {/* Shop Barber */}
        <div className="nav-link-container">
          <Link to="/storesix" className='nav-link'>✂️ Shop Barber</Link>
          <a 
            href="https://maps.google.com/maps?q=Shop+Barber" 
            target="_blank" 
            rel="noopener noreferrer"
            className="location-btn"
            title="Ver localização"
          >
            <LocationIcon />
          </a>
        </div>

        {/* Ecell Várzea Grande MT */}
        <div className="nav-link-container">
          <Link to="/storetwo" className='nav-link'>🏪 Ecell Várzea Grande MT</Link>
          <a 
            href="https://maps.app.goo.gl/hLNXtLoAAh2CsSnDA" 
            target="_blank" 
            rel="noopener noreferrer"
            className="location-btn"
            title="Ver localização"
          >
            <LocationIcon />
          </a>
        </div>

        {/* Ecell Sinop MT */}
        <div className="nav-link-container">
          <Link to="/storethree" className='nav-link'>🏪 Ecell Sinop MT</Link>
          <a 
            href="https://maps.app.goo.gl/JN5Yb5YapTRNHWXZ9" 
            target="_blank" 
            rel="noopener noreferrer"
            className="location-btn"
            title="Ver localização"
          >
            <LocationIcon />
          </a>
        </div>

        {/* Ecell Rondonópolis MT */}
        <div className="nav-link-container">
          <Link to="/storefour" className='nav-link'>🏪 Ecell Rondonópolis MT</Link>
          <a 
            href="https://maps.app.goo.gl/cBcFDcoqoVDVPjqD7" 
            target="_blank" 
            rel="noopener noreferrer"
            className="location-btn"
            title="Ver localização"
          >
            <LocationIcon />
          </a>
        </div>

        {/* Ecell Atendimento Virtual - sem localização */}
        <div className="nav-link-container">
          <Link to="/storeone" className='nav-link nav-link-full'>💻 Ecell Atendimento Virtual</Link>
        </div>

        {/* Outros Departamentos - sem localização */}
        <div className="nav-link-container">
          <Link to="/storefive" className='nav-link nav-link-full'>📦 Outros Departamentos</Link>
        </div>

        {/* Siga a gente - sem localização */}
        <div className="nav-link-container">
          <Link to="/storeeight" className='nav-link redes nav-link-full'>📱 Siga a gente!</Link>
        </div>

        {/* Baixe nosso App - sem localização */}
        <div className="nav-link-container">
          <Link to="/storenine" className='nav-link app nav-link-full'>📲 Baixe nosso App!</Link>
        </div>

      </div>
      <CopyRight/>
      
    </div>
  );
}

export default Home;